import React, { useState } from 'react';
import { getMapImageUrl } from '../../utils/formatters';
import './MapImage.css';

const MapImage = ({ imageUrl, mapName, className = '' }) => {
  const [hasError, setHasError] = useState(false);
  const fullUrl = getMapImageUrl(imageUrl);

  if (!fullUrl || hasError) {
    return (
      <div className={`map-image-placeholder ${className}`}>
        <span className="map-icon">🗺️</span>
      </div>
    );
  }

  return (
    <img
      src={fullUrl}
      alt={mapName}
      className={`map-image ${className}`}
      onError={() => setHasError(true)}
    />
  );
};

export default MapImage;
